import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-protocol-edit',
  templateUrl: `./protocol-edit.component.html`,
})
export class ProtocolEditComponent implements OnInit {

  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public selectIsDisable = false;
  public selectIsHidden = true;
  public isAdminSubscription: Subscription;
  public allProtocols: string[] = ['1.0', '1.1'];
  public hasError = false;
  public initialValue = [{}];
  public errorMessage;

  private protocol:string;

  @Input() inputValue;
  @Input() virtId;
  @Input() saveType;
  @Output() onChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private userVerificationService: UserVerificationService, private http: HttpClient) {
    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  inputOnClick() {
    this.inputIsDisable = false;
    this.hasError = false;
    this.inputIsHidden = true;
    this.selectIsDisable = true;
    this.selectIsHidden = false;
  }

  inputOnSave() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = '';
    var body: any = {};

    var url = "";
    if(this.saveType == "RC") url = ApiEndpoints.UPDATE_RC_PROTOCOL_VERSION;
    else url = ApiEndpoints.UPDATE_PROTOCOL_VERSION;

    body = {"virtId": this.virtId, "protocolVersion": this.protocol};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.hasError = false;
          this.errorMessage = "";
          this.initialValue = [{}];
          this.inputValue = this.protocol;
          this.inputIsDisable = true;
          this.inputIsHidden = false;
          this.selectIsDisable = false;
          this.selectIsHidden = true;
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.hasError = true;
          }
        }
      );
  }

  inputOnCancel(inputCheck) {
    this.inputValue = this.protocol;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
    this.hasError = false;
    this.initialValue = [{}];
    this.errorMessage = "";
  }

  selectedProtocolVersion(value:any):void {
    this.hasError = false;
    if(this.saveType == "NN") {
      if (value.split(",",1)[0] === "1.0" && this.protocol === "1.1") {
        this.hasError = true;
        this.errorMessage = "Protocol Version cannot be downgraded for the time being!!";
        return;
      }
    }
    this.protocol = value.split(",",1)[0];
    this.onChange.emit(this.protocol);
  }

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  ngOnInit() {
    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
    this.protocol = this.inputValue;
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

}
